import { render, staticRenderFns } from "./play-off-header.vue?vue&type=template&id=85568cb2&scoped=true&"
import script from "./play-off-header.vue?vue&type=script&lang=js&"
export * from "./play-off-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85568cb2",
  null
  
)

export default component.exports